module.exports = __webpack_public_path__ + "assets/img/structure-40543486.png";